module.exports = __webpack_public_path__ + "img/part1-icon.98f21e9d.png";